<template>
  <div class="right_col" role="main" style="min-height: 756px">
    <div class="">
      <div class="page-title">
        <div class="title_left">
          <h3>{{ $t('orderPage.priceInformationList') }}</h3>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
    <div class="col-md-12 col-sm-12 col-xs-12">
      <div class="x_panel item_list">
        <div class="x_content">
          <div class="text-right">
            <router-link to="/order/price/csv" class="btn btn-primary">{{
              $t('common.csvUpload')
            }}</router-link>
            <a
              :href="csvURL"
              :download="csvFileName"
              @click="csvDownLoad"
              class="btn btn-default"
              >{{ $t('common.csvDownload') }}</a
            >
          </div>
          <div
            id="datatable_wrapper"
            class="dataTables_wrapper form-inline dt-bootstrap no-footer"
          >
            <div class="row">
              <div class="col-sm-6">
                <table-length @changeRowPerPage="changeRowPerPageCount" />
              </div>
              <div class="col-sm-6">
                <div id="datatable_filter" class="dataTables_filter">
                  <label
                    >{{ $t('common.search') }}:
                    <input
                      v-model="searchString"
                      @keyup="searchWord"
                      type="search"
                      class="form-control input-sm"
                      placeholder=""
                      aria-controls="datatable"
                    />
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <app-table
                  :display-items="displayItems"
                  :column-titles="tableHeaderColumns"
                  @sortTable="sortTable"
                />
              </div>
            </div>
            <pagination
              :page-par-item-count="displayItemPerPageCount"
              :total-item-count="totalItemCount"
              :current-page="currentPage"
              @changePage="changePage"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Pagination from '@/components/tabale/Pagination'
import TableLength from '@/components/tabale/TableLength'
import Table from '@/components/common/table/Table'
import { mapGetters } from 'vuex'
import list from '@/mixin/list'
import Papa from 'papaparse'

export default {
  components: {
    Pagination,
    TableLength,
    AppTable: Table,
  },
  mixins: [list],
  data() {
    return {
      tableHeaderColumns: [
        this.$t('orderPage.pricePatternId'),
        this.$t('orderPage.pricePatternName'),
        this.$t('orderPage.priceId'),
        this.$t('orderPage.priceName'),
        this.$t('subMenu.price'),
      ],
      csvURL: '',
      csvFileName: '',
    }
  },
  computed: {
    ...mapGetters({
      fetchedData: 'price/getPrices',
      language: 'settings/getLanguage',
    }),
    defaultLanguage() {
      return process.env.VUE_APP_LANG
    },
  },
  watch: {
    fetchedData: function(newFetchedData) {
      const data = newFetchedData
      this.fetchItems = data.list.map((item) => {
        return [
          item.patternId,
          item.patternname,
          item.priceId,
          item.kindname,
          this.getPriceWithUnit(item.price),
        ]
      })
      this.allItems = this.fetchItems
      this.totalItemCount = this.allItems.length
      this.displayItems = this.allItems.slice(0, this.displayItemPerPageCount)
    },
    language() {
      this.$store.dispatch('price/getPrices')
    },
  },
  mounted() {
    this.$store.dispatch('price/getPrices')
  },
  methods: {
    getPriceWithUnit(price) {
      switch (this.defaultLanguage) {
        case 'ja':
          return `${price}${this.$t('common.yen')}`
        case 'zh-tw':
          return `${price}${this.$t('common.twGen')}`
        case 'zh-cn':
          return `${price}${this.$t('common.cnGen')}`
        case 'us':
          return `${this.$t('common.dollar', { price: price / 100 })}`
        default:
          return this.$t('common.yen')
      }
    },
    sortTable: function(newArray) {
      this.displayItems = newArray
    },
    csvDownLoad: function() {
      const items = this.fetchedData.list.map((item) => {
        return [
          this.$t('operationalManagementPage.update'),
          item.patternId,
          item.patternname,
          item.priceId,
          item.kindname,
          item.price,
        ]
      })
      const content = [
        [
          this.$t('orderPage.updateCategory'),
          this.$t('orderPage.pricePatternIdCsv'),
          this.$t('orderPage.pricePatternNameCsv'),
          this.$t('orderPage.priceId'),
          this.$t('orderPage.priceName'),
          this.$t('subMenu.price'),
        ],
      ].concat(items)
      const config = {
        delimiter: ',',
        header: true,
        newline: '\r\n',
      }
      // 区切り文字へ変換
      const delimiterString = Papa.unparse(content, config)
      // blobへの変換
      const blob = new Blob([delimiterString], { type: 'text/csv' })
      this.csvFileName = 'pricelist'
      this.csvURL = (window.URL || window.webkitURL).createObjectURL(blob)
    },
  },
}
</script>
